export class AndonNotice {
  andonNoticeID: number;
  andonID: number;
  andonName: string;
  title: string;
  causeCode: string;
  content: string;
  andonColor: string;
  message: string;
  attachment: string;
  noticeAuthor: string;
  noticeAuthorName: string;
  noticeUpdater: string;
  noticeUpdaterName: string;
  lastModifyDate: Date;
  delayFlg: boolean;
}

export class OutputAndonNoticeID {
  andonNoticeID: number;
  noticeUpdater: string;
}

export class AndonNoticeSum {
  andonGroupID: number;
  andonID: number;
  andonGroupName: string;
  andonName: string;
  infoQty: number;
  warnQty: number;
  alertQty: number;
  noResolutionQty: number;
  delayFlg: boolean;
  groupSort: number;
  andonSort: number;
}

